import 'core-js/stable';
import 'regenerator-runtime/runtime';

import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { loadableReady } from '@loadable/component';
import React from 'react';
import { hydrate } from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { useSSR } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';

import 'src/i18n';
import { App } from 'src/modules/app';
import { NonceProvider } from 'src/shared/providers';

import { ApolloClientProvider } from './ApolloClientProvider';

const BaseApp = () => {
  useSSR(window.initialI18nStore, window.initialLanguage);
  const emotionCache = createCache({ key: 'emotion' });
  return (
    <HelmetProvider>
      <NonceProvider window={window}>
        <BrowserRouter>
          <CacheProvider value={emotionCache}>
            <ApolloClientProvider>
              <App />
            </ApolloClientProvider>
          </CacheProvider>
        </BrowserRouter>
      </NonceProvider>
    </HelmetProvider>
  );
};

/**
 * Application entrypoint
 */
const main = () => {
  void loadableReady(() =>
    hydrate(<BaseApp />, document.getElementById('root')),
  );
};

if (document.readyState === 'loading') {
  // Loading hasn't finished yet
  document.addEventListener('DOMContentLoaded', main);
} else {
  main();
}

if (module.hot) {
  module.hot.accept();
}
